export default __webpack_public_path__ + "static/media/brandGuidelinesImagePage46.fce9305b.png";